module.exports = __webpack_public_path__ + "static/img/43009.f9f124a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/43009.jpg
// module id = Eopf
// module chunks = 1